import { create } from 'apisauce';
import { createApiMonitors, API_MONITORS } from '@widergy/web-utils/lib/api';
import Rollbar from 'rollbar';

import { actionCreators as AuthActions } from 'redux/authHandlers';
import store from 'redux/store';
import { TOKEN_EXPIRATION } from 'constants/analytics';
import { appConfig } from 'config/customization';

const api = create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { 'Utility-ID': appConfig.utilityId, Channel: 'web' },
  timeout: 30000
});

export const chatBotApi = create({
  baseURL: process.env.REACT_APP_CHATBOT_API_BASE_URL,
  headers: { 'Utility-ID': appConfig.utilityId, Channel: 'web' },
  timeout: 30000
});

const getCurrentAccount = () => store.getState().account.currentAccount;
const getCurrentUser = () => store.getState().auth.currentUser;
const getAuthData = () => store.getState().auth;

const monitorsOptions = {
  [API_MONITORS.SESSION_EXPIRED]: { callback: () => store.dispatch(AuthActions.signOut(TOKEN_EXPIRATION)) },
  [API_MONITORS.MISSING_PARAMETER]: {
    getMonitorParams: () => ({ currentAccount: getCurrentAccount(), currentUser: getCurrentUser() })
  },
  [API_MONITORS.INVALID_PARAMETERS]: {
    getMonitorParams: () => ({ currentAccount: getCurrentAccount(), currentUser: getCurrentUser() })
  },
  [API_MONITORS.USER_ERROR]: {
    getMonitorParams: () => ({ currentAccount: getCurrentAccount(), currentUser: getCurrentUser() })
  },
  [API_MONITORS.RECORD_NOT_UNIQUE]: {
    getMonitorParams: () => ({ currentAccount: getCurrentAccount(), currentUser: getCurrentUser() })
  },
  [API_MONITORS.ERROR_USER_UPDATE]: {
    getMonitorParams: () => ({
      currentAccount: getCurrentAccount(),
      currentUser: getCurrentUser(),
      auth: getAuthData()
    })
  }
};

export const apiSetup = () => {
  createApiMonitors(api, Rollbar, monitorsOptions);
};

export default api;
